var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.70711 10.5858V3C6.70711 2.44771 7.15482 2 7.70711 2C8.25939 2 8.70711 2.44772 8.70711 3V10.5858L11.2929 8C11.6834 7.60948 12.3166 7.60948 12.7071 8C13.0976 8.39052 13.0976 9.02369 12.7071 9.41421L8.41421 13.7071C8.02369 14.0976 7.39052 14.0976 7 13.7071L2.70711 9.41421C2.31658 9.02369 2.31658 8.39052 2.70711 8C3.09763 7.60948 3.7308 7.60948 4.12132 8L6.70711 10.5858Z","fill":"#263753"}));
}

ArrowDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
